import React, { useContext } from "react"
import { motion } from "framer-motion"
import { useTranslation } from "react-i18next"
import { isMobileContext } from "../context/isMobileContext"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/free-mode"
import "swiper/css/pagination"
import { Navigation, Pagination } from "swiper"

const OurValues = () => {
	const { isMobile } = useContext(isMobileContext)
	const { t } = useTranslation()

	const OurValues = [
		{
			icon: "/imgs/strategy/value/leaderShip1.svg",
			title: t("OurValues.title1"),
		},
		{
			icon: "/imgs/strategy/value/respect4.svg",
			title: t("OurValues.title2"),
		},
		{
			icon: "/imgs/strategy/value/Accountability5.svg",
			title: t("OurValues.title3"),
		},
		{
			icon: "/imgs/strategy/value/Commitment2.svg",
			title: t("OurValues.title4"),
		},
		{
			icon: "/imgs/strategy/value/Concern3.svg",
			title: t("OurValues.title5"),
		},
		{
			icon: "/imgs/strategy/value/Cooperation6.svg",
			title: t("OurValues.title6"),
		},
	]

	return (
		<div className="OurValues">
			<div className="img-overlay">
				<img src="/imgs/strategy/value/Subtract.png" alt="" />
			</div>
			<div className="OurValues-header">
				<div className="header-container">
					<h2 className="header">
						<div className="our-container">
							<motion.h2
								initial={{ opacity: 0, translateY: "100%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{
									ease: "easeInOut",
									delay: isMobile ? 0.1 : 0.2,
									duration: 0.5,
								}}
								className="our"
							>
								{t("OurValues.headLine1")}
							</motion.h2>
						</div>
					</h2>
				</div>
				{/* <motion.p
					initial={{ opacity: 0 }}
					whileInView={{ opacity: 1 }}
					viewport={{ once: true }}
					transition={{ ease: "easeInOut", delay: isMobile ? 0.75 : 0.5, duration: 0.5 }}
				>
					{t("OurValues.description")}
				</motion.p> */}
			</div>
			<div className="OurValues-type-cards">
				{OurValues.map((item, index) => (
					<motion.div
						initial={{ opacity: 0 }}
						whileInView={{ opacity: 1 }}
						viewport={{ once: true }}
						transition={{
							ease: "easeInOut",
							delay: isMobile
								? 0.3 + parseFloat(index * 0.055)
								: 0.75 + parseFloat(index / 10),
							duration: 0.5,
						}}
						className="card"
						key={index}
					>
						<div className="icon-wrapper">
							<img
								src={process.env.PUBLIC_URL + item.icon}
								alt="Accountability"
							/>
						</div>
						<div className="card-content">
							<div className="card-title">{item.title}</div>
						</div>
					</motion.div>
				))}
			</div>
			{/* {!isMobile ? (
        <div  
					className="OurValues-type-cards">
          {OurValues.map((item , index) => (
            <motion.div
							initial={{ opacity: 0 }}
							whileInView={{ opacity: 1 }}
							viewport={{ once: true }}
							transition={{ ease: "easeInOut", delay: isMobile ? (0.3 + parseFloat(index * 0.055)) : (0.75 + parseFloat(index/10)), duration: 0.5 }}
						 className="card" 
						 key={index}
						 >
              <div className="icon-wrapper">
                <img src={item.icon} alt="Accountability" />
              </div>
              <div className="card-content">
                <div className="card-title">
                 {item.title} 
                </div>
              </div>
            </motion.div>
          ))}
        </div> 
      ):(
      <div className="OurValues-type-cards">
        <Swiper
			  	key="swiper"
					breakpoints={{
						0: {
							slidesPerView: 1,
							spaceBetween: 25
						},
						767: {
							slidesPerView: 2.8,
							spaceBetween: 30
						},
						1200: {
							slidesPerView: 3,
							spaceBetween: 35
						},
					}}
					// centeredSlides={!isMobile ? true : false}
					// loop={!isMobile ? true : false}
					modules={[Navigation]}
					navigation={{
						nextEl: ".media-next1",
						prevEl: ".media-prev1",
					}}
					className="media-swiper"
				>
					{OurValues.map((item, index) => (
						<SwiperSlide key={index}>  
            <div className="card" key={index}>
              <div className="icon-wrapper">
                <img src={item.icon} alt="Accountability" />
              </div>
              <div className="card-content">
                <div className="card-title">
                 {item.title} 
                </div>
              </div>
            </div> 
						</SwiperSlide>
					))}
				</Swiper>
        <motion.div 
					initial={{ opacity: 0 }}
					whileInView={{ opacity: 1 }}
					viewport={{ once: true }}
					transition={{ ease: "easeInOut", delay: isMobile ? 0.6 : 1, duration: 0.5 }}
					className="media-navigation-container">
					<div className="swiper-button-prev media-prev1"></div>
					<div className="swiper-button-next media-next1"></div>
				</motion.div>
      </div> 
      )} */}
			<div className="back-layer1">
				<img
					src={
						process.env.PUBLIC_URL + "/imgs/home-page/statement-back-layer4.svg"
					}
					alt=""
				/>
			</div>
			<div className="back-layer2">
				<img src="/imgs/strategy/value/Subtract33.png" alt="" />
			</div>
			{isMobile && (
				<div className="back-layer1-mobile">
					<img
						src={process.env.PUBLIC_URL + "/imgs/home-page/vector-bg.png"}
						alt="back-layer"
					/>
				</div>
			)}
		</div>
	)
}

export default OurValues
